export default __webpack_public_path__ + "static/SRUS P389 - Especification Del Producto y Datos Técnicos-3b2502fa785130961cd46e1a188d7485.pdf";